export default {
  data() {
    return {
      asOfDate: new Date().toISOString().slice(0, 10),
    };
  },

  methods: {
    todayIsoDate() {
      return new Date().toISOString().slice(0, 10);
    },

    applyAsOfDateToTable(tableRefName) {
      const table = this.$refs[tableRefName];
      if (!table) {
        return;
      }

      const merged = {
        ...(table.serverFilters || {}),
        as_of_date: this.asOfDate || this.todayIsoDate(),
      };

      table.serverFilters = merged;
      table.serverHandleFiltersChange(merged, table.options);
    },

    onAsOfDateChange(value) {
      this.asOfDate = value || this.todayIsoDate();
      this.$nextTick(() => {
        this.applyAsOfDateToTable(this.stockTableRef);
      });
    },

    initAsOfDateFromTable(tableRefName, { useToday = false } = {}) {
      const table = this.$refs[tableRefName];
      if (!table) {
        return;
      }

      if (useToday) {
        this.asOfDate = this.todayIsoDate();
      } else {
        const persisted = table.serverFilters && table.serverFilters.as_of_date;
        this.asOfDate = persisted || this.asOfDate || this.todayIsoDate();
      }

      this.$nextTick(() => {
        this.applyAsOfDateToTable(tableRefName);
      });
    },
  },
};
